import type { AppVersionInfo } from '@shopexperts/shared'

export const loadedAppVersion = Object.freeze({
  app: 'dashboard',
  channel: 'nightly',
  version: '2.2642.1',
  releasedAt: '2026-10-13T12:29:04.251Z',
  minimumSupported: Object.freeze({
    gentle: '2.2642.1',
    error: '2.2633.2',
    unsupported: '2.2633.2',
  }),
}) satisfies Readonly<AppVersionInfo>
